module.exports = __webpack_public_path__ + "static/careDemo2-1598c27cb37504068e1b680e67f54fe7.svg";